exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.time-entry-modal-dialog[data-v-1183777d] {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n.border-bottom[data-v-1183777d] {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n/* Ensure proper scrolling in modal content */\n.overflow-auto[data-v-1183777d] {\n  overflow: auto;\n}\n.overflow-hidden[data-v-1183777d] {\n  overflow: hidden;\n}\n", ""]);

// exports
